function showByRoleDirective(Identity) {
	return ({
		restrict : "A",
		transclude : false,
		link : function(scope, element, attrs) {
			scope.$watch(attrs.showByRole, function(value, oldValue) {
				
				if (!_.isString(attrs.showByRole)) {
					throw 'hasRole value must be a string'
				}

				var roles = attrs.showByRole.split(',');
				element.hide();
				for (var i = 0; i < roles.length; i++) {
					if (Identity.hasRole(roles[i])) {
						element.show();
						break;
					}
				}

			}, true);
		}
	});
}

module.directive('showByRole', [ 'Identity', showByRoleDirective ]);